jQuery(document).ready(function(){	
	
	jQuery('.home-slider').slick({
		infinite: true,
		slidesToShow: 5,
		slidesToScroll: 1,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 2000,
		responsive: [
	    {
	      breakpoint: 760,
	      settings: {
		  	centerMode: true,
		  	centerPadding: '80px',
		  	slidesToShow: 1
	      }
	    },
	    
	    ]
	
	});
	
});